<template>
  <section class="benefits-section">
    <div class="benefit">
      <div class="side-media">
        <img class="fullw" src="/assets/autonomia.jpg" />
      </div>
      <div class="content nomargin">
        <div id="Autonomia" class="content-header blue">
          <div class="maxw">
            <h2>Autonomía</h2>
          </div>
        </div>
        <div class="content-body">
          <div class="maxw">
            <p>
              La distancia que puede recorrer un auto eléctrico nuevo entre los
              modelos disponibles en Costa depende de la potencia de la batería,
              así como las condiciones reales del recorrido. Así que la
              distancia alcanzable sería mayor en el viaje de San José a Jacó,
              por pasar de una altura de 1 kilómetro a la del nivel del mar,
              mientras la batería se descargaría de forma rápida en la vuelta,
              al ser cuesta arriba.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="benefit">
      <div class="content">
        <div id="Estaciones" class="content-header green">
          <div class="maxw">
            <h2>Estaciones de carga</h2>
          </div>
        </div>
        <div class="content-body">
          <div class="maxw">
            <p>
              Hay más de 100 estaciones de recarga rápida en el país, operadas
              sobre por el ICE y la CNFL, se encuentran en la app Plugshare para
              IOS o Android o la versión web
              <a href="https://plugshare.com" target="_blank">plugshare.com</a>.
            </p>
            <img src="/assets/features-bat.jpg" />
          </div>
        </div>
      </div>
      <div class="side-media iframe-container">
        <iframe
          src="https://www.plugshare.com/widget2.html?latitude=9.7489&longitude=-83.7534&spanLat=1.59024&spanLng=1.59024&plugs=1,2,3,4,5,6,42,13,7,8,9,10,11,12,14,15,16,17"
          width="800"
          height="600"
          allow="geolocation"
        ></iframe>
      </div>
    </div>
    <div class="benefit gray">
      <div class="content ">
        <div id="Bateria" class="content-header blue">
          <div class="maxw">
            <h2>Batería</h2>
          </div>
        </div>
        <div class="content-body ">
          <div class="maxw">
            <p>
              Las baterías de los vehículos eléctricos ofrecidos en Costa Rica
              se cargan con la corriente convencional de una casa, oficina u
              otro lugar con el enchufe de 110 voltios. También se puede cargar
              en enchufes de 220 para una carga más rápida y hasta 480 voltios
              en cargadores super rápidos. El tiempo de la carga completa
              depende del vehículo y el voltaje, a menudo se trata de varias
              horas en la carga convencional.
            </p>
          </div>
        </div>
      </div>
      <div class="side-media">
        <div class="content-header blue iconbar">
          <img class="iconimg" src="/assets/icons/bateria.svg" />
        </div>
        <img class="fullw" src="/assets/bateria.jpg" />
      </div>
    </div>
    <div class="benefit">
      <div class="content ">
        <div id="Autos" class="content-header blue">
          <div class="maxw white">
            <h2>Cantidad de autos eléctricos</h2>
          </div>
        </div>
        <div class="content-body ">
          <div class="maxw">
            <p>
              La importación de los autos eléctricos en el país va en aumento,
              tal como indican los datos del Ministerio de Ambiente (datos de
              autos, no incluyen motos o vehículos comerciales).
            </p>
            <img class="grafico-electricos" src="/assets/grafico1.jpg" />
          </div>
        </div>
      </div>
      <div class="content nomargin">
        <div id="Rendimiento" class="content-header blue">
          <div class="maxw">
            <h2>Rendimiento y Beneficios</h2>
          </div>
        </div>
        <div class="content-body ">
          <div class="maxw ">
            <p class="bigger">
              La batería pierde fuerza a través de los años, con lo que se
              reduce la autonomía. Sin embargo, el vehículo opera a alto nivel
              durante varios años, incluso varias marcas de vehículos garantizan
              el rendimiento por un mínimo de 8 años o 100.000 kilómetros.Una
              vez que el rendimiento se reduzca, se puede comprar una nueva
              batería.
            </p>
            <p class="bigger">
              En el carro eléctrico, el motor impulsa las ruedas de forma
              directa e inmediata, en el momento que recibe la energía de la
              batería.Con esto, se puede aprovechar la aceleración rápida en un
              momento oportuno, dadas las condiciones del tránsito.En
              comparación, se trata del tiempo en el vehículo convencional de
              presionar el acelerador, lo que procura la inyección de
              combustible y aire en la cámara de compresión, la combustión de la
              mezcla, y la impulsación del pistón, cuya energía debe
              transferirse a las ruedas mediante una serie de palancas y
              engranajes.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="benefit">
      <div class="side-media stroked">
        <img class="fullw" src="/assets/impcto-ambiental.jpg" />
      </div>
      <div class="content ">
        <div id="Impacto" class="content-header green nomargin">
          <div class="maxw">
            <h2>Impacto Ambiental</h2>
          </div>
        </div>
        <div class="content-body nomargin">
          <div class="maxw">
            <p>
              El carro eléctrico conserva el medio ambiente, al no emitir los
              gases invernaderos. El vehículo convencional, por su parte,
              produce dióxido de carbono, una de las principales causas del
              calentamiento global, al quemar el combustible fósil, sea gasolina
              o diesel. Los principales contaminantes incluyen: Dióxido de
              carbono, Monóxido de carbono, Óxidos nitrosos, Compuestos
              orgánicos volátiles, Material particulado y Azufre. Hay un impacto
              ambiental en la producción de las baterías, la que consume una
              cantidad significativa de energía.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="benefit">
      <div class="content-body single">
        <p>
          Hay también el riesgo de contaminación por varios metales y minerales
          tóxicos, si la batería se botara en el suelo o en el agua.Sin embargo,
          el uso del carro eléctrico a través de los años elimina la
          contaminación de los gases invernaderos emitidos por los carros
          convencionales, mientras se puede reciclar la batería una vez que
          termine su vida útil.Incluso, la batería poco útil para el vehículo
          tendría una segunda vida en el almacenamiento eléctrico en la casa u
          otra edificación.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BenefitsComponent",
  data() {
    return {
      title: "Título"
    };
  }
};
</script>

<style scoped lang="scss">
.benefits-section {
  position: relative;
  margin: 4rem 0;

  .benefit {
    position: relative;
    display: flex;
    > div {
      flex: 1;
      width: 50%;
    }

    .side-media {
      position: relative;
      padding-bottom: 25%;

      &.stroked {
        margin-top: -3rem;
        &:before {
          content: "";
          position: absolute;
          top: 3rem;
          left: 0;
          height: 6.25rem;
          width: 100%;
          background: radial-gradient(
            circle,
            rgba(48, 152, 77, 0.1) 30%,
            rgba(48, 152, 77, 0.7) 100%
          );
          z-index: 2;
        }
      }

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }

    img.fullw {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .maxw {
      @media #{$md} {
        width: 500px;
        max-width: 100%;
        display: block;
        margin-right: 0;
        margin-left: auto;
      }
    }

    .nomargin .maxw {
      @media #{$md} {
        margin-left: 0;
      }
    }

    .content-body {
      padding: 2rem;
      font-weight: 500;
      width: 100%;

      img {
        margin-top: 1rem;
        @media #{$md} {
          width: 425px;
        }
      }

      img.grafico-electricos {
        margin-left: -3rem;
        width: auto;
        max-width: calc(100% + 4rem);
      }

      @media #{$md} {
        p {
          max-width: 400px;
          width: 100%;
        }
        &.single {
          max-width: 930px;
          margin: auto;
          p {
            max-width: 100%;
          }
        }
      }
    }

    .content-header {
      position: relative;
      display: flex;
      align-items: center;
      padding: 0 2rem;
      height: 6.25rem;

      .maxw.white {
        padding: 2rem;
        background: #fff;
        height: 100%;
        display: flex;
        align-items: center;
        h2 {
          color: #1a1a1a;
        }
        @media #{$md} {
          padding: 1em 2rem;
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          width: calc(500px + 4em);
        }
      }

      h2 {
        color: #fff;
        font-size: 2rem;
        margin: 0;
      }

      &.blue {
        background: $blue;
      }

      &.green {
        background: $green;
      }
    }

    .content-header.blue.iconbar {
      position: relative;
      z-index: 1;
      padding: 1rem !important;
      height: 6.25rem;
      background: rgb(4 99 188 / 80%);

      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: radial-gradient(
          circle,
          rgba(30, 96, 170, 0) 80%,
          rgba(30, 96, 170, 1) 100%
        );
      }

      .iconimg {
        position: relative;
        width: 4rem;
        height: 3rem;
      }
    }

    &.gray {
      background: #dbdfe2;
    }
  }

  table.electicos-table {
    max-width: 125px;
    border-spacing: 5px;

    td,
    th {
      border: none;
      padding: 3px 0;
    }

    span {
      display: inline-block;
      background: #2e8adf;
      color: #fff;
      padding: 5px 10px;
      border-radius: 5px;
      font-size: 0.8rem;
    }
  }

  @media only screen and (max-width: 767px) {
    .benefit {
      flex-direction: column;
    }
    .side-media {
      padding-bottom: 90% !important;
    }
    .benefit > div {
      width: 100%;
    }

    .benefit .side-media.stroked::before {
      top: 0rem;
    }

    .benefit .side-media.stroked {
      margin-top: 1em;
    }
  }
}
</style>
